import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme.js";

export default {
	darkMode: "class",
	theme: {
		extend: {
			fontFamily: {
				sans: ["Inter", ...defaultTheme.fontFamily.sans],
				heading: ["Syne", ...defaultTheme.fontFamily.sans],
			},
			fontSize: {
				xs: ["12px", "1"], // pills & buttons //d
				sm: ["0.9375rem", "1.6"], // small text
				base: ["17px", "1.55"], // default text //d
				"menu-item": ["4rem", "1"], // menu item
				p: ["1rem", "1.4"], // p //d
				button: ["1rem", "1"], // button text //d
				"button-mobile": ["8px", "10px"], // mobile button text
				"text-mobile": ["12px", "140%"], // mobile text
				pmd: ["24px", "1.5"], // price cards text //d
				md: ["20px", "1.3"], // text medium //d
				"2md": ["1.375rem", "1.1"],
				lg: ["32px", "1.1"], // cards heading //d
				"h1-mobile": ["32px", "110%"], // mobile h1
				"2lg": ["2rem", "1.15"], //
				xl: ["2.5rem", "1.15"], // footer claim
				"2xl": ["3rem", "1.15"],
				"3xl": ["64px", "1.1"], // h1 //d
			},
			// Prefix colors with shortcut of project name (example: fastest -> fstgreen)
			colors: {
				ivory: {
					100: "#F7F3EF",
					200: "#EEE6DD",
					300: "#E5D9CC",
					400: "#DDCCBB",
					500: "#D4BFAA",
				},
				hazelnut: {
					100: "#906456",
					200: "#80594C",
					300: "#704E43",
					400: "#604339",
					500: "#4F372F",
				},
				midnight: "#21212F",
				copper: {
					100: "#CE6D4F",
					200: "#C95C3B",
					300: "#B85233",
				},
				"copper-20": {
					100: "#75B3B3",
					200: "#64AAAA",
					300: "#7F8F77",
				},
			},
			keyframes: {
				slideDown: {
					"0%": { transform: "translateY(-100%)" },
					"100%": { transform: "translateY(0)" },
				},
				slideUp: {
					"0%": { transform: "translateY(0)" },
					"100%": { transform: "translateY(-100%)" },
				},
			},
			animation: {
				slideDown: "slideDown 0.3s ease-out",
				slideUp: "slideUp 0.3s ease-out",
			},
		},
	},
} satisfies Partial<Config>;
